export default __webpack_public_path__ + "static/media/Anjali J Parappattu1.42b6654a.jpeg";